export const FR: Record<string, string> = {
  "Recommended for you": "Recommandé pour vous",
  "Resource added to favorite": "Ressource ajoutée aux favoris",
  "Failed to add resource to favorite": "Échec de l'ajout de la ressource aux favoris",
  "Resource removed from favorite": "Ressource supprimée des favoris",
  "Failed to remove resource from favorite": "Échec de la suppression de la ressource des favoris",
  "Calendar": "Calendrier",
  "View Detail": "Voir les détails",
  "Add to favorites": "Ajouter aux favoris",
  "Remove from favorites": "Supprimer des favoris",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Description : Salle de réunion VIP avec une vue magnifique et des chaises confortables.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Il n'y a pas de ressources disponibles à l'heure choisie à votre emplacement ou dans vos favoris.",
  "You have these options:": "Vous avez ces options :",
  "Change the meeting time.": "Modifier l'heure de la réunion.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Utilisez le bouton <1>Trouver un créneau disponible</1> pour choisir une nouvelle heure.",
  "Open the search to find other resources.": "Ouvrez la recherche pour trouver d'autres ressources.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Le type de ressource <1>'{{resourceType}}'</1> n'existe pas à votre emplacement par défaut",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Le type de ressource <1>'{{resourceType}}'</1> peut être trouvé à un emplacement différent.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Cliquez ici</1> pour ajouter le type de ressource à vos paramètres d'emplacement par défaut.",
  
  // ResourceCard
  "New Order": "Nouvelle commande",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Lors de la réservation d'un Pooled Resource, seul ce type de ressource et seulement un peuvent être réservés.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Vous ne pouvez pas sélectionner à la fois un ressource enfant et son ressource virtuelle en même temps.",
  // Settings
  "Note:": "Remarque :",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Un organisateur assistant peut recevoir les mêmes e-mails de Resource Central que l'organisateur et peut traiter les commandes au nom de l'organisateur.",
  "Setting updated successfully": "Paramètre mis à jour avec succès",
  "Setting updated failed": "Échec de la mise à jour du paramètre",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 place",
  "Opening hours:": "Heures d'ouverture :",
  "Buffer time {{minutes}} mins between reservations": "Temps tampon {{minutes}} min entre les réservations",
  "Initial payment {{value}} pr.minute": "Paiement initial {{value}} par minute",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Total {{total}} participants",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} sur {{total}} internes peuvent participer.",
  "{{external}} external is unknown.": "{{external}} externes sont inconnus.",
  "Find available time": "Trouver un créneau disponible",
  "Attendees": "Participants",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Cliquez sur Plus d'informations pour visiter notre site d'assistance",
  "Further information": "Plus d'informations",
  
  // LocationSetting
  "Location changed": "Emplacement modifié",
  "Location change failed": "Échec de la modification de l'emplacement",
  "Please select at least one location": "Veuillez sélectionner au moins un emplacement",
  "Resource types": "Types de ressources",
  "Location": "Emplacement",
  "Where": "Où",
  
  // ModalShowAttendees
  "Total": "Total",
  "Available": "Disponible",
  "Busy": "Occupé",
  "External": "Externe",
  "Internal": "Interne",
  
  // ResourceSearch
  "Search by resource name": "Rechercher par nom de ressource",
  "Category": "Catégorie",
  "Filter by Location": "Filtrer par emplacement",
  "Filter by Category": "Filtrer par catégorie",
  "Capacity": "Capacité",
  "Filter by Capacity": "Filtrer par capacité",
  "All": "Tout",
  "Filter by availability": "Filtrer par disponibilité",
  "Sort By": "Trier par",
  "Loading...": "Chargement...",
  
  // SelectedResources
  "Meeting Type": "Type de réunion",
  "Meeting Label": "Étiquette de réunion",
  
  // Alert (accessibility text)
  "Check icon": "Icône de vérification",
  "Close": "Fermer",
  
  // AppConstants - searchTab
  "Resource": "Ressource",
  "Person": "Personne",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Où se déroulent habituellement vos réunions ?",
  "To improve our recommendations for you we would like you to enter your normal location": "Pour améliorer nos recommandations pour vous, nous aimerions que vous entriez votre emplacement habituel",
  "What do you use most?": "Qu'utilisez-vous le plus ?",
  "To enable quicker and better search please chose you prefered resource type": "Pour permettre une recherche plus rapide et meilleure, veuillez choisir votre type de ressource préféré",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Cliquer sur la ressource pour sélectionner",
  "Selected Resources": "Ressources sélectionnées",
  "Setting": "Paramètre",
  "Search": "Recherche",
  "Find Colleague": "Trouver un collègue",
  "Quick button setting": "Paramètre du bouton rapide",
  "Favorite": "Favori",
  "Most Used": "Les plus utilisés",
  "Colleagues": "Collègues",
  "Resources": "Ressources",
  
  // AppConstants - tooltipText
  "Back": "Retour",
  "Floor Plan": "Plan d'étage",
  "Expand": "Développer",
  "Selected resources": "Ressources sélectionnées",
  "View details": "Voir les détails",
  "Remove from My Favorites": "Retirer de mes favoris",
  "Add to My Favorites": "Ajouter à mes favoris",
  "Remove": "Supprimer",
  "Favorite - Most Used": "Favori - Les plus utilisés",
  "Conflict": "Conflit",
  "Approved": "Approuvé",
  "Recommendeded for you": "Recommandé pour vous",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Uniquement l'organisateur principal",
  "Only assistant organizer": "Uniquement l'organisateur assistant",
  "Primary AND assistant organizer": "Organisateur principal ET assistant",
  
  // FindColleague
  "Enter colleague name": "Entrez le nom du collègue",
  "Recent work items": "Éléments de travail récents",
  "No data available": "Aucune donnée disponible",
  "Floorplan": "Plan d'étage",
  "List nearby resources": "Liste des ressources à proximité",
  "Find resource nearby": "Trouver une ressource à proximité",
  "No Resources available": "Aucune ressource disponible",
  
  // Start page
  "Next": "Suivant",
  "Failed to update default locations": "Échec de la mise à jour des emplacements par défaut",
  "Resource Type": "Type de ressource",
  
  // QuickSetting
  "Quick buttons updated successfully": "Boutons rapides mis à jour avec succès",
  "Quick buttons updated failed": "Échec de la mise à jour des boutons rapides",
  "Add more": "Ajouter plus",
  "Apply": "Appliquer",
  "Delete": "Supprimer",
  "Name": "Nom",
  "Enter name": "Entrer le nom",
  "Tooltip": "Info-bulle",
  "Enter tooltip": "Entrer l'info-bulle",
  "Type": "Type",
  "Select type": "Sélectionner le type",
  "Locations": "Emplacements",
  "Select colleagues": "Sélectionner des collègues",
  "Select resources": "Sélectionner des ressources",
  
  // DefaultResourceSetting
  "Resource type changed": "Type de ressource modifié",
  "Resource type change failed": "Échec de la modification du type de ressource",
  "Default Resource Type": "Type de ressource par défaut",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Appliqué avec succès",
  "Apply Failed": "Échec de l'application",
  "Assistant Organizer": "Organisateur assistant",
  "Enter a part of the name to search for": "Entrez une partie du nom pour rechercher",
  "Mail Flow": "Flux de courrier",
  "Select Mail Flow": "Sélectionner le flux de courrier",
  
  // TileConfigurationSetting
  "Update settings successfully": "Paramètres mis à jour avec succès",
  "Update settings failed": "Échec de la mise à jour des paramètres",
  "Timeline": "Chronologie",
  
  // SelectCategoryForm
  "And": "Et",
  "Or": "Ou",
  
  // Other
  "Resource Calendar": "Calendrier des ressources",
  
  // SettingLabels
  "Default Location": "Emplacement par défaut",
  "Quick button": "Bouton rapide",
  "Category icons": "Icônes de catégorie",
  "Recommendation screen": "Écran de recommandation",
  "Capacity filter": "Filtre de capacité",
  "AI Assistant": "Assistant IA",
  "Tile configuration": "Configuration des tuiles",
  "Help": "Aide",
  "Default Categories": "Catégories par défaut",
  
  // MeetingType
  "Your must select a Meeting label": "Vous devez sélectionner une étiquette de réunion",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Ressource sélectionnée: 'AOD_Copanhagen' Occurrences conflictuelles",
  "Alternative Resource": "Ressource alternative",
  "OK": "OK",
  "Cancel": "Annuler",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Votre ressource sélectionnée 'AOD_Copenhagen' a été supprimée",
  "You can't book this resource as your request exceeds the available capacity.": "Vous ne pouvez pas réserver cette ressource car votre demande dépasse la capacité disponible.",
  
  // ChangeTime
  "Time changed successfully": "Heure modifiée avec succès",
  "Current Time": "Heure actuelle",
  "Suggested Times": "Heures suggérées",
  "Change Time": "Changer l'heure",
  "people are free": "personnes sont disponibles",
};

